<!-- 饼图 -->
<template>
    <div>
        <div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:baseConfig?.title?.textShow?'flex':'none', height: baseConfig.title?.Height + 'px'}">
            <div class="img-icon" :style = "{ width: baseConfig.title?.textWidth + 'px', height: baseConfig.title?.textHeight + 'px', marginLeft: baseConfig.title?.textLeft + 'px', marginRight: baseConfig.title?.textRight + 'px',display:baseConfig?.title?.textIcon?'block':'none'}">
                <img style="height:100%;width:100%" :src="commenUrl+baseConfig?.title?.textIcon" alt="">
            </div>
            <div style="flex:1" :style = "{ fontSize: baseConfig.title?.textSzie + 'px', color: baseConfig.title?.textColor,textAlign: baseConfig.title?.textAlign}">{{baseConfig?.title?.textTitle}}</div>
        </div>
        <div class="chart_box" id='chart_box' :class="baseConfig.animation"  :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px'}">
        <div id="main" class="chart1" ref='barChartRef' :style = "{ left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
    </div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
    props: {
        index: {
            type:Number ,
            default: function () { return {} }
        },
        yearRef:{
            type: String,
            default: function () { return "2024" }
        }
    },
    setup(props) {
       
        const { proxy } = getCurrentInstance();
        const store = useStore();
        const index = ref(props.index);
        const baseConfig = ref({})
        const series = ref()
        const componentList = ref(computed(() => store.state.chartData.componentList));
        const chartData = ref(computed(() => store.state.chartData));
        baseConfig.value = componentList.value[index.value].config.baseConfig
    let legendList =[]
    const  seriesAdd =(type)=>{
        legendList=[]
      series.value= componentList.value[index.value].data.echartsData.map((item,indexs)=>{
        // name
       
        legendList.unshift(item.name)
        let componentList1
             if(type==0||componentList.value[index.value].config.options.series){
                componentList1=componentList.value[index.value].config.options.series
             }
          
           return{ 
             name: item.name,
             type: 'pie',
             center: type==0||componentList1[0].center?componentList1[0].center:[baseConfig.value.width /2, baseConfig.value.height /2],
             radius:[30+indexs*15+'%', 40+indexs*15+'%'], // 内环和外环的半径
             avoidLabelOverlap: type==0?componentList1[0].avoidLabelOverlap:false,
             label: type==0?componentList1[0].label:false,
             startAngle:type==0?componentList1[0].startAngle: 90,
             clockWise: type==0?componentList1[0].clockWise:true, //顺时加载
             hoverAnimation: type==0?componentList1[0].hoverAnimation:true,
             hoverOffset: type==0?componentList1[0].hoverOffset:3,
             emphasis: {
                 label: {
                     show: false,
                     fontSize: '20',
                     fontWeight: 'bold'
                 }
             },
             labelLine: {
             length: 0,
             length2: 0,
             lineStyle: {
             width: 2,
             },
             },
             data:  JSON.parse(JSON.stringify(item.value))
             }
             
     })
      }
      seriesAdd()
        const project = ref(computed(() => store.state.project));
        const option = ref({})
        const danwei=ref()
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
        const handleResize = () => {
            chartInstance.value.resize();
        };
        watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
            // console.log(newVal,'3333333');
                if(newVal){
                    // seriesAdd()
                    chartInit()
                }
            },{ deep: true }
        )
        watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    seriesAdd(0)
                    chartInit()
                }
            },{ deep: true }
        ) 
        watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
                if(newVal){
                    // console.log(componentList.value[index.value].config.baseConfig,'componentList.value[index.value].config.baseConfig')
                    baseConfig.value = componentList.value[index.value].config.baseConfig
                    // chartInit()
                   setTimeout(()=>{
                    handleResize()
                   })
                    // chart_box = d
                    //
                }
            },{ deep: true }
        ) 
        onMounted(() => {
            chartInstance.value = echarts.init(barChartRef.value);
            chartInit() 
            window.addEventListener('resize', handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
        var placeHolderStyle = {
            normal: {
                color: "#fff",
                opacity: 0.1,
            },
            emphasis: {
                color: "#fff",
                opacity: 0.1,
            },
        };
        const chartInit = ()=>{
            
            chartInstance.value.clear()     
            option.value =componentList.value[index.value].config.options
            // console.log(option.value,'option.value')
            option.value.tooltip.formatter= function (params) {
                        if(params.data.name =="背景"){
                            return ''
                        }
                        // 创建一个包含自定义样式的 HTML 字符串  
                        return  `  
                            <div style=" border-radius: 5px;">  
                                <div>${params.name}</div>  
                                <div >${params.value}万元</div>  
                            </div>  
                        `
                    }

        option.value.series.forEach(item => {  
          if(!option.value.btshow){
            item.data.forEach((items,index)=>{
                if(items.name=='背景'){
                  item.data.splice(index,1)
                }
          })
          }
          else{
          let Index=  item.data.findIndex((items)=>{return items.name=='背景'})
          if(Index==-1){
            item.data.push({
                    value: 100,
                    name: "背景",
                    hoverAnimation: false,
                    itemStyle: placeHolderStyle,
                })
          }
        
          }
        }); 
       
             option.value.legend.data=legendList
             option.value.series =series.value
             chartInstance.value.setOption(option.value);
            // chartData.value.componentList[index.value].config.options=option.value
            // store.commit("setChartData", chartData.value); 
            
        }
        return{
            option,
            barChartRef,
            baseConfig

        }
    }
}
</script>

<style scoped>
.chart_box {position: relative;}
.chart1 {
    width: 100%;
   height: 100%;
   position: absolute;
}

</style>